<template>
  <box-model title="土壤墒情">
    <template v-slot:content>
      <div v-if="selList.length" class="select-part">
        <select-box :sty="false" :list="selList" :item="selItem" @sel="selEvent" keyword="id"></select-box>
      </div>
      <div class="con">
        <div class="detail-part flex-center">
          <div class="dp-info">
            <img class="d-img" src="../../assets/img/trsd.png" />
            <div class="t-part left flex-column-p">
              <div>土壤湿度</div>
              <div><span class="num">{{detail.humidity || '--'}}</span> %</div>
            </div>
          </div>
          <div class="d-positon flex-column-pm">
            <div style="color: #4ADDFF">测量位置</div>
            <div>5CM土壤测量点</div>
          </div>
          <div class="dp-info">
            <img class="d-img" src="../../assets/img/trwd.png" />
            <div class="t-part right flex-column-p">
              <div>土壤温度</div>
              <div><span class="num">{{ detail.temperature || '--' }}</span> ℃</div>
            </div>
          </div>
        </div>
        <div class="count-part">
          <div class="cp-item flex-y-center">
            <div>盐分</div>
            <div class="cp-num">{{ detail.specific_conductance || '--' }}</div>
            <div class="cp-unit flex-y-center">mg/kg</div>
          </div>
          <div class="cp-item flex-y-center">
            <div>含氮量</div>
            <div class="cp-num">{{ detail.nitrogen || '--' }}</div>
            <div class="cp-unit flex-y-center">mg/kg</div>
          </div>
          <div class="cp-item flex-y-center">
            <div>含磷量</div>
            <div class="cp-num">{{ detail.phosphor || '--' }}</div>
            <div class="cp-unit flex-y-center">mg/kg</div>
          </div>
        </div>
        <div class="count-part">
          <div class="cp-item flex-y-center">
            <div>含钾量</div>
            <div class="cp-num">{{ detail.kalium || '--' }}</div>
            <div class="cp-unit flex-y-center">mg/kg</div>
          </div>
          <div class="cp-item flex-y-center">
            <div>PH</div>
            <div class="cp-num">{{ detail.ph_num || '--' }}</div>
          </div>
        </div>
      </div>
    </template>
  </box-model>
</template>
<script>
  import { getIotSoilsList, getByIdAndType } from "@/api/index";
  export default {
    data() {
      return {
        selList: [],
        selItem: {},

        detail: {},

        rList: []
      }
    },
    components: {
      "box-model": () => import("../../components/common/Model.vue"),
      "select-box": () => import("../../components/common/SelectBox.vue")
    },
    mounted(){
      this.getIotSoilsListEvent();
    },
    methods: {
      selEvent(item){
        this.selItem = item;
        this.getByIdAndTypeEvent(item.code);
      },
      getIotSoilsListEvent(){
        getIotSoilsList().then((res) => {
          this.selList = res.data.records || [];
          if(this.selList.length){
            this.selItem = this.selList[0];
            this.getByIdAndTypeEvent(this.selItem.code);
          }
        })
      },
      getByIdAndTypeEvent(code){
        getByIdAndType({
          devType: 'soils',
          code: code
        }).then((res) => {
          const result = res.data || {};
          this.detail = res.data;
          this.rList = [
            {name: '盐分', num: result.specific_conductance || 0, unit: 'mg/kg'},
            {name: '含氮量', num: result.nitrogen || 0, unit: 'mg/kg'},
            {name: '含磷量', num: result.phosphor || 0, unit: 'mg/kg'},
            {name: '含钾量', num: result.kalium || 0, unit: 'mg/kg'},
            {name: 'PH', num: result.ph_num || 0 }
          ]
        })
      }
    }
  }
</script>
<style scoped lang="less">
  .flex-column-p {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .flex-column-pm {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .select-part {
    position: absolute;
    top: -10px;
    right: 20px;
    width: 100px;
    font-size: 14px;
    font-weight: 400;
  }
  .con {
    width: 100%;
    height: 218px;
    padding-top: 40px;
    .detail-part {
      width: 100%;
      height: 48px;
      margin-bottom: 40px;
      .dp-info {
        position: relative;
        width: 152px;
        height: 48px;
        .d-img {
          position: absolute;
          z-index: 0;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
        }
        .t-part {
          position: relative;
          z-index: 3;
          width: 100%;
          height: 100%;
          font-size: 18px;
          font-weight: 400;
          color: rgba(255,255,255,0.702);
          line-height: 18px;
        }
        .left {
            padding-left: 24px;
          .num {
            font-size: 26px;
            font-weight: 700;
            color: #FFFFFF;
            line-height: 26px;
          }
        }
        .right {
          padding-right: 24px;
          text-align: right;
          .num {
            font-size: 26px;
            font-weight: 700;
            color: #FFFFFF;
            line-height: 26px;
          }
        }
      }
      .d-positon {
        height: 100%;
        margin: 0 45px;
        font-size: 18px;
        font-weight: 700;
        color: #FFFFFF;
        line-height: 20px;
      }
    }
    .count-part {
      display: flex;
      width: 100%;
      .cp-item {
        position: relative;
        width: 32%;
        height: 32px;
        margin-right: 1.5%;
        background: rgba(9,148,255,0.14);
        margin-bottom: 10px;
        padding-right: 62px;
        padding-left: 14px;
        font-size: 18px;
        font-weight: 400;
        color: #FFFFFF;
        .cp-num {
          font-size: 22px;
          font-weight: 700;
          color: #4ADDFF;
          margin-left: auto;
        }
        .cp-unit {
          position: absolute;
          top: 0;
          right: 4px;
          height: 100%;
          font-size: 18px;
          font-weight: 400;
          color: rgba(255,255,255,0.7);
        }
      }
      .cp-item::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 4px;
        height: 100%;
        border-top: 1px solid #38EAFF;
        border-bottom: 1px solid #38EAFF;
        border-left: 1px solid #38EAFF;
      }
      .cp-item::after {
        content: '';
        position: absolute;
        top: 0;
        right: 0;
        width: 4px;
        height: 100%;
        border-top: 1px solid #38EAFF;
        border-bottom: 1px solid #38EAFF;
        border-right: 1px solid #38EAFF;
      }
      .cp-item:last-child {
        margin-right: 0;
      }
    }
  }
</style>